import { IJourneyInfo } from './flights/journeyParamsInfo';

export class MainFormDinamicTexts {
  searchDetailsTexts?: IJourneyInfo;
  dinamicRoute?: string;
  dinamicIcon?: string;
  dinamicText?: string;
}
